export const contactGeneralStepValidationRules = {
  firstNameMaxLength: 75,
  lastNameMaxLength: 75,
  emailMaxLength: 254,
}
